








































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment'
import AlertArea from "../../components/AlertArea.vue"
import { BCarousel } from 'bootstrap-vue';
import { Sheet } from "../../modules/student/SheetUpload"
import jsZip from "jszip";
// @ts-ignore
import VueDragResize from "vue-drag-resize";

export interface Data {
  sheet_id: string
  sheet: Sheet
  pageNo: number
  baseWidth: number
  baseHeight: number
  angle: number
  posSettingScale: number
  transformedScale: number
  translateX: number
  translateY: number
  circleSize: number
  progress: number
  base64Image: string
  rotates: number[]
  cornerPosArray: any[]
  images: any[]
  blobImages: any[]
  carouselPageIdx: number
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
  },
  setup(props, context){

    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: new Sheet(),
      pageNo: 1,
      baseWidth: 0,
      baseHeight: 0,
      angle: 0,
      posSettingScale: 1,
      transformedScale: 1,
      translateX: 0,
      translateY: 0,
      circleSize: 60,
      // 作業進捗 0:画像ドラッグする段階 1:ドラッグ画像読み込んだ状態 2:補正後画像のプレビュー状態 3:全画像補正済みの最終確認
      progress: 0,
      base64Image: "",
      rotates: [0, 90, 180, 270],
      cornerPosArray: [],
      // 補正後の画像(Base64)
      images: [],
      // 補正後の画像(Blob)
      blobImages: [],
      carouselPageIdx: 0,
      errors: new Array<string>()
    });

    /******************************
     * computed
     ******************************/

    const posSettingImageStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      style["width"] = `${state.baseWidth * state.posSettingScale}px`;
      return style;
    });

    const transformedImageStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      if(state.sheet.correct_image_size != undefined){
        style["width"] = `${state.sheet.correct_image_size[0] * state.transformedScale}px`;
      }
      return style;
    });

    const tdStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      style["width"] = `${circleCenter.value}px`;
      style["height"] = `${circleCenter.value}px`;
      return style;
    });

    const circleCenter = computed((): number => {
      return state.circleSize / 2;
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/student/sheet_upload?sheet_id=${state.sheet_id}`).then(response => {
        const sheet = new Sheet();
        sheet.grade = response.data.sheet.grade;
        sheet.name = response.data.sheet.name;
        sheet.curriculum_id = response.data.sheet.curriculum_id;
        sheet.page_count = response.data.sheet.page_count;
        sheet.correct_image_size = response.data.sheet.correct_image_size;
        sheet.sheet_process = response.data.sheet.sheet_process;
        state.sheet = sheet;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$router.push(`/${context.root.$store.state.currentUser.school_id}/student_site/sheet_list`).catch(err => {});
      });
      context.root.$store.dispatch("hideOverlay");

    });

    /******************************
     * methods
     ******************************/

    // 画像ドロップ
    const onDrop = (event: any) => {
      var files = context.root.$store.state.isMobile ? event.target.files : event.dataTransfer.files;

      if(files.length > 1){
        alert("複数ファイルは選択できません。");
        return;
      }

      // 拡張子チェック
      var extentions = ["jpg", "jpeg"];
      var file_work = files[0].name.split('.');
      if(!extentions.includes(file_work[file_work.length - 1].toLowerCase())) {
        alert(`選択可能なファイルは[${extentions}]です。`);
        return;
      }

      // FileReaderを生成
      var fileReader = new FileReader();

      fileReader.onload = function(e){
        state.base64Image = e.target.result as string;

        // 原寸大のサイズ取得のためImageオブジェクトに画像読み込み
        var img = new Image();
        img.onload = function(){

          // 原寸大のサイズ取得
          state.baseWidth = img.width;
          state.baseHeight = img.height;

          state.angle = 0;
          state.posSettingScale = state.baseWidth > window.innerWidth ? window.innerWidth / (state.baseWidth + 100) : 1;

          var canvas = <HTMLCanvasElement> document.getElementById("image-canvas");
          canvas.width = state.baseWidth;
          canvas.height = state.baseHeight;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, state.baseWidth, state.baseHeight, 0, 0, state.baseWidth, state.baseHeight);

          createCornerPosArray();
        };
        img.src = state.base64Image;
      };
      fileReader.readAsDataURL(files[0]);
      state.progress = 1;
    };

    // 枠設定用サークル生成
    const createCornerPosArray = () => {
      var cornerPosArray = new Array();
      
      for(var i = 0; i < 4; i++){
        var cornerPos = [];
        cornerPos[0] = i == 0 || i == 1 ? 100 : state.baseWidth - 100;
        cornerPos[1] = i == 0 || i == 3 ? 100 : state.baseHeight - 100;
        cornerPosArray.push(cornerPos);
      }
      
      state.cornerPosArray = cornerPosArray;
    };

    // 枠設定サークルの位置名取得
    const getPosName = (idx: number) => {
      var posName = "";
      if(idx == 0){
        posName = "左上";
      }else if(idx == 1){
        posName = "左下";
      }else if (idx == 2){
        posName = "右下";
      }else{
        posName = "右上";
      }
      return posName;
    };

    // 枠設定用サークルドラッグ終了後
    const dragStop = (idx: number, rect: any) => {
      state.cornerPosArray[idx][0] += 1;
      state.cornerPosArray[idx][1] += 1;
      context.root.$nextTick(() => {
        var circleCenter = state.circleSize / 2;
        var x = Math.round(rect.left + circleCenter) / state.posSettingScale;
        var y = Math.round(rect.top + circleCenter) / state.posSettingScale;

        if(x < 0){
          x = 0;
        }else if(x > state.baseWidth){
          x = state.baseWidth;
        }
        if(y < 0){
          y = 0;
        }else if(y > state.baseHeight){
          y = state.baseHeight;
        }
        state.cornerPosArray[idx][0] = x;
        state.cornerPosArray[idx][1] = y;
      });
    };

    // 左回転ボタン処理
    const rotateLeft = () => {
      var rotateIdx = state.rotates.indexOf(state.angle);
      if(rotateIdx == 0){
        state.angle = 270;
      }else{
        state.angle -= 90;
      }
      rotate();
    };

    // 右回転ボタン処理
    const rotateRight = () => {
      var rotateIdx = state.rotates.indexOf(state.angle);
      if(rotateIdx == 3){
        state.angle = 0;
      }else{
        state.angle += 90;
      }
      rotate();
    };

    // 回転メイン処理
    const rotate = () => {
      var img = new Image();
      img.onload = function(){
        var canvas = <HTMLCanvasElement> document.getElementById("image-canvas");
        var ctx = canvas.getContext('2d');

        // 描画済みの画像をクリア
        ctx.clearRect(0, 0, img.width, img.height);

        // 回転後の画像サイズ設定
        canvas.width = state.angle == 0 || state.angle == 180 ? img.width : img.height;
        canvas.height = state.angle == 0 || state.angle == 180 ? img.height : img.width;
        state.baseWidth = state.angle == 0 || state.angle == 180 ? img.width : img.height;
        state.baseHeight = state.angle == 0 || state.angle == 180 ? img.height : img.width;

        // 回転の中心軸設定
        if(state.angle == 0){
          state.translateX = 0;
          state.translateY = 0;
        }else if(state.angle == 90){
          state.translateX = state.baseWidth;
          state.translateY = 0;
        }else if(state.angle == 180){
          state.translateX = state.baseWidth;
          state.translateY = state.baseHeight;
        }else{
          state.translateX = 0;
          state.translateY = state.baseHeight;
        }

        ctx.translate(state.translateX, state.translateY);
        ctx.rotate(state.angle * Math.PI / 180);
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width, img.height);
        
        state.posSettingScale = state.baseWidth > window.innerWidth ? window.innerWidth / (state.baseWidth + 100) : 1;
        createCornerPosArray();
      };
      img.src = state.base64Image;
    };

    // 拡大
    const scaleUp = () => {
      state.posSettingScale += 0.02;
    };

    // 縮小
    const scaleDown = () => {
      state.posSettingScale -= 0.02;
    };

    // 画像変更
    const changeImage = () => {
      state.progress = 0;
    };

    // 画像補正処理実行
    const executeTransform = () => {
      if(!window.confirm("画像の補正処理を実行します。よろしいですか？")){
        return;
      }

      var self = this;
      var canvas = <HTMLCanvasElement> document.getElementById("image-canvas");
      var type = "image/jpeg";

      canvas.toBlob(async function(canvasBlob){
        if (canvasBlob) {
          var fd = new FormData();
          fd.append('file', canvasBlob);
          fd.append('json_corner_pos_array', JSON.stringify(state.cornerPosArray));
          fd.append("json_correct_image_size", JSON.stringify(state.sheet.correct_image_size));
          fd.append("sheet_id", state.sheet_id);
          
          context.root.$store.dispatch("showOverlay");
          await http.post(`/api/student/sheet_upload/transform`, fd, {responseType: 'blob'}).then(response => {
            state.progress = 2;
            const blob = response.data;

            var img = new Image();
            img.onload = function(){
                var canvas = <HTMLCanvasElement> document.getElementById("transformed-canvas");
                canvas.width = state.sheet.correct_image_size[0];
                canvas.height = state.sheet.correct_image_size[1];
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, state.sheet.correct_image_size[0], state.sheet.correct_image_size[1], 0, 0, state.sheet.correct_image_size[0], state.sheet.correct_image_size[1]);
            }
            img.src = window.URL.createObjectURL(blob);
            state.transformedScale = state.sheet.correct_image_size[0] > window.innerWidth ? window.innerWidth / (state.sheet.correct_image_size[0] + 100) : 1;
            state.blobImages[state.pageNo -1] = blob;
          })
          .catch(error=>{
            if(error.response.status == 422){
              state.errors = error.response.data.errors;
            }else{
              state.errors = ["予期せぬ例外が発生しました。"];
            }
          });
          context.root.$store.dispatch("hideOverlay");
        }
      }, type);
    };

    // やり直しボタンクリック
    const resetTransform = () => {
      state.progress = 1;
    };

    // 補正後の画像プレビューで確定ボタンクリック
    const setImage = () => {
      const canvas = <HTMLCanvasElement> document.getElementById("transformed-canvas");
      state.images[state.pageNo -1] = canvas.toDataURL("image/png");

      if(state.images.length == state.sheet.page_count){
        state.progress = 3;
      }else{
        state.progress = 0;
        state.pageNo += 1;
      }
    };

    // 画像選択やり直しボタンクリック
    const resetImage = () => {
      if(!window.confirm(`${state.carouselPageIdx + 1}ページ目の画像選択からやり直します。よろしいですか？`)){
        return;
      }
      state.progress = 0;
      state.pageNo = state.carouselPageIdx + 1;
    };

    // 送信ボタンクリック
    const upload = () => {
      if(!window.confirm(`ファイルをアップロードします。よろしいですか？`)){
        return;
      }
      var canvas = <HTMLCanvasElement> document.getElementById("transformed-canvas");
      var type = "image/jpeg";

      let zip = new jsZip();
      for(var i = 0; i < state.blobImages.length; i++){
        zip.file(`${i + 1}.jpg`, state.blobImages[i]);
      }
      
      zip.generateAsync({type: "blob"}).then(async function(blob){
        if (blob) {
          var fd = new FormData();
          fd.append('file', blob);

          context.root.$store.dispatch("showOverlay");
          await http.post(`/api/student/sheet_upload/upload/${state.sheet.sheet_process.id}/${context.root.$store.state.student_no_character}`, fd).then(response => {
            alert("アップロードが完了しました。");
            window.history.back();
          })
          .catch(error=>{
            if(error.response.status == 422){
              state.errors = error.response.data.errors;
            }else{
              state.errors = ["予期せぬ例外が発生しました。"];
            }
          });
          context.root.$store.dispatch("hideOverlay");
        }
      });
    };

    // 画像前ページへ
    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.images.length - 1;
      }
    };

    // 画像次ページへ
    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.images.length){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    // 戻る矢印アイコンクリック
    const progressBack = () => {
      if(window.confirm("アップロードを途中で終了します。よろしいですか？")){
        window.history.back();
      }
    };

    return {
      ...toRefs(state),
      carouselRef,
      tdStyle,
      posSettingImageStyle,
      transformedImageStyle,
      circleCenter,
      onDrop,
      getPosName,
      createCornerPosArray,
      dragStop,
      rotateLeft,
      rotateRight,
      rotate,
      scaleUp,
      scaleDown,
      changeImage,
      executeTransform,
      resetTransform,
      setImage,
      resetImage,
      upload,
      carouselPrev,
      carouselNext,
      progressBack,
    };
  }
});
